import { Cube } from './cube';

export class RubiksCube {
  public cubes: Cube[] = [];

  constructor() {
    this._generateCubes();
  }

  private _generateCubes() {
    for (let x = 0; x < 3; x++) {
      for (let y = 0; y < 3; y++) {
        for (let z = 0; z < 3; z++) {
          this.cubes.push(new Cube(x, y, z));
        }
      }
    }
  }
}
